'use client'
import React from 'react'

const hiddenElementStyles = {
  opacity: 0,
  pointerEvents: 'none',
  clipPath: 'inset(50%)',
  position: 'absolute',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
}

const HiddenIframe = ({ url }) => {
  // Extract just the URL part if it contains additional attributes
  const cleanUrl = url.split('"')[1] || url
  return (
    <iframe
      src={cleanUrl}
      title="Video content"
      className="absolute h-full w-full"
      style={hiddenElementStyles}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  )
}

export { HiddenIframe }
export default HiddenIframe
